module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/apprenticeFistUp-5390131095151e6e55b467351470b1b0.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/apprenticeFistUp.png
// module id = 2361
// module chunks = 2